tiz.directive('popover', ['$document', function($document) {
  var WINDOW_PADDING = 40;

  return {
    restrict: 'E',
    transclude: true,
    scope: {show: '=?', inverted: '<', popoverClass: '='},
    templateUrl: require('../templates/popover/popover.html'),
    controller: ['$scope', '$document', '$timeout', function($scope, $document, $timeout) {
      this.closePopover = function() {
        $scope.show = false;
        $scope.$emit('popover-closed');
        $scope.$root.safeApply();
      };

      this.applyListener = function() {
        $document.on('click', this.closePopover);
      }.bind(this);
      this.removeListener = function() {
        $document.off('click', this.closePopover);
      }.bind(this);

      $scope.$watch('show', function(newValue, oldValue) {
        if(newValue === true) {
          $timeout(this.applyListener, 0);
        } else {
          this.removeListener();
        }
      }.bind(this));
    }],
    link: function(scope, element, attrs, controller) {
      var stopProp = function(event) {
        event.stopPropagation();
      };

      element.on('click', stopProp);
      element.on('$destroy', controller.removeListener);
      element.on('$destroy', function() {
        element.off('click', stopProp);
      });

      scope.$watch('show', function(newValue, oldValue) {
        setTimeout(function() {
          var positioner = element.find('.popover-position')[0];
          if (!positioner) { return; }
          var popover = element.find('.provi-popover')[0];
          var popoverArrow = element.find('.popover__arrow')[0];
          var popoverArrowPositioner = element.find('.popover__arrow-position')[0];

          if (newValue == true && popover) {
            var positionerPosition = positioner.getBoundingClientRect();
            var popoverPosition = popover.getBoundingClientRect();
            var arrowPosition = popoverArrow.getBoundingClientRect();
            var arrowPositionerPosition = popoverArrowPositioner.getBoundingClientRect();

            var positionerCenter = positionerPosition.right - positionerPosition.left;
            var popoverCenter = popoverPosition.right - popoverPosition.left;

            // Position popover body
            if (popoverPosition.left < WINDOW_PADDING) {
              positioner.style.transform = 'translateX(' + (WINDOW_PADDING - popoverPosition.left) + 'px)';
              popoverArrowPositioner.style.transform = 'translateX(' + -(WINDOW_PADDING - popoverPosition.left) + 'px)';
            } else if (popoverPosition.right > window.innerWidth - WINDOW_PADDING) {
              positioner.style.transform = 'translateX(' + (window.innerWidth - WINDOW_PADDING - popoverPosition.right) + 'px)';
              popoverArrowPositioner.style.transform = 'translateX(' + -(window.innerWidth - WINDOW_PADDING - popoverPosition.right) + 'px)';
            }
          } else {
            positioner.style.transform = '';
          }
        });
      });
    }
  };
}]);
